import * as Types from '../constants/Types';

export const getSupplierList = (params) => ({ type: Types.SUPPLIER_LIST_ACTION, params });
export const setSupplierList = (data) => ({ type: Types.SUPPLIER_LIST_SUCCESS, ...data });

export const getSupplierProductGenerate = (id) => ({ type: Types.SUPPLIER_PRODUCT_GENERATE_ACTION, id });
export const setSupplierProductGenerate = (data) => ({ type: Types.SUPPLIER_PRODUCT_GENERATE_SUCCESS, ...data });

export const getSupplierListAll = (params) => ({ type: Types.SUPPLIER_LIST_ALL_ACTION, params });
export const setSupplierListAll = (data) => ({ type: Types.SUPPLIER_LIST_ALL_SUCCESS, ...data });

export const getSupplierSelectList = () => ({ type: Types.SUPPLIER_SELECT_LIST_ACTION });
export const setSupplierSelectList = (supplierSelectData) => ({ type: Types.SUPPLIER_SELECT_LIST_SUCCESS, supplierSelectData });

export const getSupplierDetail = (id) => ({ type: Types.SUPPLIER_GET_DETAIL_ACTION, id });
export const setSupplierDetail = (supplier) => ({ type: Types.SUPPLIER_GET_DETAIL_SUCCESS, supplier });

export const createSupplierAction = (supplier, callbacks) => ({ type: Types.SUPPLIER_CREATE_ACTION, supplier, callbacks });
export const updateSupplierAction = (supplier, callbacks) => ({ type: Types.SUPPLIER_UPDATE_ACTION, supplier, callbacks });
export const deleteSupplierAction = (supplier, refreshParams) => ({ type: Types.SUPPLIER_DELETE_ACTION, supplier, refreshParams });

export const getSupplierDetailAddFAQs = (id) => ({ type: Types.SUPPLIER_GET_DETAIL_FAQs_ACTION, id });
export const setSupplierDetailFAQ = (supplier) => ({ type: Types.SUPPLIER_GET_DETAIL_FAQS_SUCCESS, supplier });
export const createSupplierAddFAQsAction = (supplierFAQs, callBacks) => ({ type: Types.SUPPLIER_CREATE_FAQS_ACTION, supplierFAQs, callBacks });
export const deleteSupplierAddFAQsAction = (id, supplierId) => ({ type: Types.SUPPLIER_DELETE_FAQS_ACTION, id, supplierId });

export const getAllSupplierProduct = (params) => ({ type: Types.SUPPLIER_PRODUCT_LIST_ALL_ACTION, params });
export const setAllSupplierProduct = (supplierProducts) => ({ type: Types.SUPPLIER_PRODUCT_LIST_ALL_SUCCESS, supplierProducts });

export const getSupplierProducts = (params) => ({ type: Types.SUPPLIER_PRODUCT_LIST_ACTION, params });
export const setSupplierProducts = (supplierProducts) => ({ type: Types.SUPPLIER_PRODUCT_LIST_SUCCESS, supplierProducts });

export const getSupplierProductDetail = (id) => ({ type: Types.SUPPLIER_PRODUCT_GET_DETAIL_ACTION, id });
export const setSupplierProductDetail = (supplierProduct) => ({ type: Types.SUPPLIER_PRODUCT_GET_DETAIL_SUCCESS, supplierProduct });

// export const getSupplierUsagePlanDetail = (id, query, payload = {}) => ({ type: Types.SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_ACTION, id, query, ...payload });
export const getSupplierUsagePlanDetail = (id, payload = {}) => ({ type: Types.SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_ACTION, id, ...payload });


export const setSupplierUsagePlanDetail = (supplierUsagePlan) => ({ type: Types.SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_SUCCESS, supplierUsagePlan });

export const createSupplierProductAction = (supplierProduct) => ({ type: Types.SUPPLIER_PRODUCT_CREATE_ACTION, supplierProduct });
export const updateSupplierProductAction = (supplierProduct) => ({ type: Types.SUPPLIER_PRODUCT_UPDATE_ACTION, supplierProduct });
export const deleteSupplierProductAction = (supplierProduct, refreshParams) => ({ type: Types.SUPPLIER_PRODUCT_DELETE_ACTION, supplierProduct, refreshParams });

export const getVinwonderSites = () => ({ type: Types.SUPPLIER_VINWONDER_SITES_ACTION });
export const setVinwonderSites = (data) => ({ type: Types.SUPPLIER_VINWONDER_SITES_SUCCESS, ...data });

export const getVinwonderTypes = () => ({ type: Types.SUPPLIER_VINWONDER_TYPES_ACTION });
export const setVinwonderTypes = (data) => ({ type: Types.SUPPLIER_VINWONDER_TYPES_SUCCESS, ...data });

export const getVinwonderRefIds = (params) => ({ type: Types.SUPPLIER_VINWONDER_REFIDS_ACTION, params });
export const setVinwonderRefIds = (data) => ({ type: Types.SUPPLIER_VINWONDER_REFIDS_SUCCESS, ...data });

export const createSupplierTranslate = (supplier) => ({ type: Types.SUPPLIER_CREATE_TRANSLATE_ACTION, supplier });
export const updateSupplierTranslate = (supplier) => ({ type: Types.SUPPLIER_UPDATE_TRANSLATE_ACTION, supplier });
export const deleteSupplierTranslate = (supplier, refreshParams) => ({ type: Types.SUPPLIER_DELETE_TRANSLATE_ACTION, supplier, refreshParams });
